<template>
  <div>
    <b-container>
      <div>
        <b-modal v-model="modalShow">{{ messagge }}</b-modal>
      </div>
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(next)" autocomplete="off">
          <b-card>
            <template #header>
              <h6 class="mb-0">Datos del Asegurado</h6>
            </template>
            <b-row>
              <b-col md="8" cols="12">
                <CheckComponent
                  :form="form"
                  name="planMultiple"
                  rules="required"
                  :options="control.TIPOS_PLAN_GENERAL"
                  disabled
                  label="Tipo de Póliza"
                />
              </b-col>            
            </b-row>
            <b-row>
              <b-col md="3" cols="12">
                <TextComponent
                  :form="form"
                  name="lastName"
                  label="Primer Apellido"
                  rules="required"
                  disabled
                />
              </b-col>
              <b-col md="3" cols="12">
                <TextComponent :form="form" name="secondLastName"
                 label="Segundo Apellido" disabled />
              </b-col>
              <b-col md="3" cols="12">
                <TextComponent
                  :form="form"
                  name="firstName"
                  label="Primer Nombre"
                  rules="required"
                  disabled
                />
              </b-col>
              <b-col md="3" cols="12">
                <TextComponent :form="form" name="secondFirstName" 
                label="Segundo Nombre" />
              </b-col>
            </b-row>

            <b-row>
              <b-col md="4" cols="12">
                <TextComponent
                  :form="form"
                  name="email"
                  label="Correo Electrónico"
                  rules="required|email"
                  disabled
                />
              </b-col>
              <b-col md="2" cols="12">
                <TextComponent
                  :form="form"
                  name="birthDayFormat"
                  label="Fecha de Nacimiento"
                  rules="required"
                  type="date"
                  disabled
                />
              </b-col>

              <b-col md="2" cols="12">
                <RadioComponent
                  :form="form"
                  name="sex"
                  label="Género"
                  rules="required"
                  disabled
                  :options="control.TIPOS_SEXO"
                />
              </b-col>

              <b-col md="2" cols="12">
                <SelectComponent
                  :form="form"
                  name="identificationType"
                  label="Tipo Documento"
                  rules="required"
                  :options="control.IdentificationsType"
                  disabled
                />
              </b-col>

                       
              <b-col md="2" cols="12">
                <TextComponent
                  :form="form"
                  name="identification"
                  label="Número de Identificación"
                  rules="required"
                  disabled
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col md="3" cols="12">
                <TextComponent :form="form" name="ocupacity" label="Actividad" />
              </b-col>
              <b-col md="3" cols="12">
                <TextComponent :form="form" name="adress" 
                               label="Dirección Residencia" rules="required|max:60" />
              </b-col>
              <b-col md="3" cols="12">
                <TextComponent :form="form" name="city" label="Ciudad" rules="required|max:30" />
              </b-col>
              <b-col md="3" cols="12">
                <TextComponent :form="form" name="apart" label="Departamento" rules="max:30" />
              </b-col>
            </b-row>

            <b-row>
          
              <b-col md="4" cols="12">
                <TextComponent :form="form" name="phone" 
                        label="Teléfono Residencia" rules="required" />
              </b-col>
              <b-col md="4" cols="12">
                <TextComponent :form="form" name="phoneOffice" label="Tel. Oficina" />
              </b-col>
              <b-col md="4" cols="12">
                <TextComponent :form="form" name="PhoneMobile" label="Celular" />
              </b-col>
            </b-row>

            <b-row>
              <b-col md="2" cols="12">
                <TextComponent
                  :form="form"
                  name="valorAseguradoActual"
                  type="number"
                  label="Valor Asegurado Actual"
                />
              </b-col>
              <b-col md="3" cols="12">
                <TextComponent
                  :form="form"
                  name="valorAseguradoSolicitado"
                  type="number"
                  label="Valor Asegurado Solicitado"
                />
              </b-col>
              <b-col md="3" cols="12">
                <TextComponent
                  :form="form"
                  name="salary"
                  type="number"
                  label="Salario Mensual"
                />
              </b-col>
           
              <b-col md="2" cols="12">
                <TextComponent
                  :form="form"
                  name="stature"
                  type="number"
                  label="Estatura (m)"
                  step="0.01"
                  placeholder="Ej: 1.70"
                />
              </b-col>
              <b-col md="2" cols="12">
                <TextComponent
                  :form="form"
                  name="weight"
                  type="number"
                  label="Peso (kg)"
                  placeholder="Ej: 70"
                />
              </b-col>
            </b-row>

            <b-row align-h="end" class="mt-4">
              <b-col md="4" cols="4" style="display: flex; justify-content: flex-end">
                <b-button type="submit" variant="primary">Siguiente</b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-form>
      </validation-observer>
    </b-container>
  </div>
</template>

<script>
import RadioComponent from "@/components/controls/RadioComponent.vue";
import SelectComponent from "@/components/controls/SelectComponent.vue";
import TextComponent from "@/components/controls/TextComponent.vue";
import CheckComponent from "@/components/controls/CheckComponent.vue";
import {
  TIPOS_IDENTIFICACIONES,
  TIPOS_POLIZA,
  TIPOS_PROCEDIMIENTO,
  TIPOS_SEXO,
  TIPOS_PLAN_GENERAL
} from "../../../data/colombia/Selects";
import { planType } from "../../../helpers/reglasColombia";

export default {
  name: "FormColombia01",
  components: { TextComponent, RadioComponent, SelectComponent, CheckComponent },
  data() {
    return {
      messagge: "",
      control: {
        IdentificationsType: TIPOS_IDENTIFICACIONES,
        TIPOS_POLIZA,
        TIPOS_PROCEDIMIENTO,
        TIPOS_SEXO,
        TIPOS_PLAN_GENERAL
      },
      form: {},
      modalShow: false,
    };
  },
  mounted() {
    this.$store.dispatch("app/loading", true);
    const { form } = this.$store.state.wizard;
    if (form === undefined || form === null || form === "") {
      this.$router.push("/form/colombia/");
      return;
    }
    this.form = form;    
    this.form.planMultiple = planType(this.form.observations);

    this.$store.dispatch("app/loading", false);
  },
  methods: {
    next() {
      this.$store
        .dispatch("wizard/save", { index: 1, form: this.form })
        .then(() => this.$router.push("/form/colombia-2.html"));
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 1600px;
}
</style>
